export const getUpdatedImageUrl = (imageUrl: string | undefined) => {
  if (!imageUrl) return imageUrl;

  const cf: string = process.env.REACT_APP_CLOUDFRONT ?? "";
  const cloudflare_cdn = process.env.REACT_APP_CLOUDFLARE_CDN ?? "";
  const cloudflare_delimiter = "cloudflarestorage.com/";
  const bucket: string = process.env.REACT_APP_BUCKET_URL ?? "";

  if (imageUrl.includes(cloudflare_delimiter) && cloudflare_cdn.length > 0) {
    const image = imageUrl.split(cloudflare_delimiter)[1];

    return `${cloudflare_cdn}/${image}`;
  }

  console.log('getUpdatedImageUrl - no changes to image url required')
  if (cf === "") return imageUrl;
  
  return imageUrl.replace(bucket, cf);
};

export const getNonProxiedCloudflareUrl = (imageUrl: string | undefined) => {
  if (!imageUrl) return imageUrl;
  
  const cloudflare_bucket_url= process.env.REACT_APP_R2_FULL_BUCKET_URL
  const cloudflare_cdn = process.env.REACT_APP_CLOUDFLARE_CDN ?? "";
  
  if (imageUrl.includes(cloudflare_cdn)) {
    const image = imageUrl.split(`${cloudflare_cdn}/`)[1];

    return `${cloudflare_bucket_url}${image}`;
  }

  return imageUrl
};

export const getImageUrlFromResult = (imageUrl: string | undefined) => {
  if (!imageUrl) return "";

  const url = imageUrl.split("?")[0];

  // if the cloudflare proxy is enabled, then the image won't be viewable to the user, so get the updated url
  return getUpdatedImageUrl(url) ?? ''
};
